import { Head, Link } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { PlaceForm, type PlaceFormRecord } from "./Form"

type Option = { id: number; label: string; key?: string }

export default function AdminPlacesNew({
  place,
  destination_options,
  category_options,
  statuses,
  schema_types,
}: {
  place: PlaceFormRecord
  destination_options: Option[]
  category_options: Option[]
  statuses: string[]
  schema_types: string[]
}) {
  return (
    <>
      <Head title="New place" />
      <AdminShell>
        <div className="border-b border-hairline pb-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
            <div>
              <h1>New place</h1>
              <p className="mt-1">Add a visitable or useful point in a destination.</p>
            </div>
            <Link href="/admin/places" className="text-sm text-ink-muted no-underline hover:text-ink-display">Back to places</Link>
          </div>
        </div>
        <PlaceForm
          place={place}
          destinationOptions={destination_options}
          categoryOptions={category_options}
          statuses={statuses}
          schemaTypes={schema_types}
          action="/admin/places"
          method="post"
          submitLabel="Create place"
        />
      </AdminShell>
    </>
  )
}
